<script>
import { apiService } from "@/_services";
import proposalEntry from "@/components/proposals-entry";
export default {
  name: "single-aplication",
  components: {
    proposalEntry
  },
  created() {
    if (this.$route.params.hasOwnProperty("data")) {
      this.data = this.$route.params.data;
      this.prefilled = true;
    } else {
      this.loading = true;
    }
    this.getData();
  },
  data() {
    return {
      loading: false,
      prefilled: false,
      data: {}
    };
  },
  computed: {
    id() {
      // return 0;
      return this.$route.params.id || 0;
    },
    unlocked() {
      return this.data.hasOwnProperty("unlocked") && this.data.unlocked;
    },
    author() {
      // return false;
      return this.data.hasOwnProperty("author") ? this.data.author : false;
    },
    proposals() {
      // return this.data.hasOwnProperty("proposals") ? this.data.proposals : [];
      if (this.data.hasOwnProperty("proposals")) {
        // return this.data.proposals;
        let cloned = JSON.parse(JSON.stringify(this.data.proposals));
        let data = this.data;
        cloned.forEach(function(proposal) {
          if (proposal.hasOwnProperty("amount")) {
            if (proposal.amount < data.amount) {
              proposal.amountIs = "less";
            } else if (proposal.amount > data.amount) {
              proposal.amountIs = "more";
            } else {
              proposal.amountIs = "equal";
            }
          }
          if (proposal.hasOwnProperty("term")) {
            if (proposal.term < data.term) {
              proposal.termIs = "less";
            } else if (proposal.term > data.term) {
              proposal.termIs = "more";
            } else {
              proposal.termIs = "equal";
            }
          }
          // console.log(proposal);
        });
        return cloned;
      }
      // return [];
      return false;
    }
  },
  methods: {
    getData() {
      this.loading = true;
      apiService.applications.get(this.id).then(response => {
        this.data = response.data;
        this.loading = false;
      });
    },
    back() {
      if (history.length > 1) {
        console.log(history.length);
        this.$router.back();
      } else {
        this.$router.push({ name: "finder" });
      }
    }
  },
  watch: {
    id() {
      this.prefilled = false;
      this.getData();
    }
  }
};
</script>

<template>
  <div class="view" id="singleApplication">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <span class="bar__title">Aplicación</span>
          </div>
          <div class="rowColumn">
            <span class="reference">{{ data.reference }}</span>
          </div>
        </div>
      </div>
    </div>
    <sapp-loading v-if="loading && !prefilled" :grow="true" />
    <div v-else class="view__content application">
      <div class="container">
        <div class="content_area side side--left">
          <div class="sbox sbox-lvl-1 application_banner gradient-primary">
            <div class="sbox-pad">
              <div class="type" :class="'type-' + data.type">
                <div class="wrapper">
                  <i class="sappfont" :class="'sappfont-loan-' + data.type"></i>
                </div>
              </div>
              <div class="amount">
                <span class="numbers">{{ data.amount | formatMoney }}</span>
              </div>
              <div
                class="term"
                v-html="
                  data.term > 1 ? data.term + ' meses' : data.term + ' mes'
                "
              ></div>
              <div class="date">{{ data.date }}</div>
              <!-- <h1>Application {{ id }}</h1> -->
              <!-- <p>{{ data.type }}</p> -->
              <p v-if="data.unlocked" class="lock-status">Desbloqueada</p>
              <p v-else>Desbloquea esta aplicación</p>

              <!-- <span>Estado de solicitud</span> -->
              <!-- <p v-if="data.closed">Solucionada</p> -->
              <!-- <p else>Abierta</p> -->
            </div>
          </div>
          <div v-if="unlocked" class="sbox sbox-pad application_author">
            <div class="sbox-lvl-1">
              <div class="sbox-pad sbox-header">
                <h4 class="sbox-title">Información del Aplicante</h4>
              </div>
              <div v-if="author" class="sbox-pad">
                <div class="sfields">
                  <div class="sfield sfield--dislpay_name">
                    <span class="sfield__label">Nombre:</span>
                    <span class="sfield__content">{{
                      data.author.display_name
                    }}</span>
                  </div>
                  <div class="sfield sfield--nid">
                    <span class="sfield__label">Cédula:</span>
                    <span class="sfield__content">{{ data.author.nid }}</span>
                  </div>
                  <div class="sfield sfield--birthdate">
                    <span class="sfield__label">Nacimiento:</span>
                    <span class="sfield__content">{{
                      data.author.birthdate
                    }}</span>
                  </div>

                  <div class="sfield sfield--phone">
                    <span class="sfield__label">Tel. Residencial:</span>
                    <span class="sfield__content">{{
                      data.author.phone_residence
                    }}</span>
                  </div>

                  <div class="sfield sfield--phone">
                    <span class="sfield__label">Tel. Móvil:</span>
                    <span class="sfield__content">{{
                      data.author.phone_mobile
                    }}</span>
                  </div>

                  <div class="sfield sfield--email">
                    <span class="sfield__label">Email:</span>
                    <span class="sfield__content">{{
                      data.author.user_email
                    }}</span>
                  </div>
                </div>
                <br />
                <router-link
                  :to="'/profile/' + data.author.profile"
                  class="button is-info"
                  title="Visitar perfil"
                  >Ir al perfil de aplicante</router-link
                >
              </div>
              <div v-else class="sbox-pad">
                <sapp-loading :grow="true" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="unlocked" class="content_area">
          <div id="related-proposals" class="sbox sbox-pad">
            <h4 class="sbox-title">Propuestas Publicadas</h4>
            <div v-if="proposals">
              <div v-if="proposals.length" class="hfeed hfeed-proposals">
                <proposalEntry
                  v-for="(proposal, index) in proposals"
                  :key="index"
                  :proposal="proposal"
                />
              </div>
              <div v-else>
                <p>Esta aplicación aun no ha recibido propuestas públicas</p>
              </div>
            </div>
            <sapp-loading v-else :grow="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media only screen {
  // #singleApplication .container {
  //   max-width: 75rem;
  // }
  .application_banner {
    // background: #4d67ef;
    // background: #4705b1;
    // background: #061387;
    // background: linear-gradient(160deg, #4608ad, #32067c);
    // background: linear-gradient(180deg, #061387, #4259ed);
    // background: linear-gradient(180deg, #4259ed, #061387);
    // background: linear-gradient(180deg, #32067c, #4608ad);
    // background: linear-gradient(180deg, #061387, #4259ed);
    color: #fff;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 2.5rem;
    display: table;
    width: 100%;
    min-height: 15rem;
    .content {
      display: table-cell;
      vertical-align: middle;
    }
    .type .wrapper {
      display: inline-block;
      background-color: #5616ed;
      background-color: #4608ad;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      margin-bottom: 1rem;
      padding: 2rem;
      i {
        display: block;
        font-size: 8rem;
        width: 8rem;
        height: 8rem;
        fill: #fff;
      }
    }
    .amount {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.2;
      font-size: 1.25rem;
      font-weight: 400;
      letter-spacing: 1px;
      color: rgba(255, 255, 255, 0.6);
      margin-top: -2.5rem;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
    }
    .amount .numbers {
      font-weight: 700;
      font-size: 2.125rem;
      font-size: 2rem;
      color: #fff;
      position: relative;
    }
    .amount .numbers:before {
      position: absolute;
      content: "$";
      opacity: 0.5;
      font-size: 1rem;
      top: 0.25rem;
      left: -0.75rem;
    }
    .term {
      line-height: 1.2;
      font-size: 1.25rem;
      font-weight: 600;
      color: #00a6ff;
      color: #37cfb1;
    }
    .date {
      margin-top: 2rem;
    }
  }
  .sfield {
    padding: 0.25rem;
    margin-bottom: 0.5rem;
    display: flex;
    // flex-direction: column-reverse;
    align-items: center;
    font-size: 0.75rem;
    .sfield__label {
      padding-right: 1rem;
      font-weight: 500;
      color: #516f90;
      font-weight: 400;
    }
    .sfield__content {
      // font-size: 0.875rem;
      font-weight: bold;
      padding: 0.125rem 0;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .sfield:not(:last-child) {
    border-bottom: 1px dashed #dfe3eb;
  }
  @media (max-width: 39.9375em) {
    #singleApplication {
      .view__bar {
        position: absolute;
        z-index: 2;
        background-color: transparent;
        width: 100%;
        border: none;
        box-shadow: none;
        color: #fff;
        // .level {
        //   width: 100%;
        // }
        .bar__title {
          display: none;
        }
        .app-back,
        .title,
        .subtitle {
          color: #fff;
        }
        .title,
        .subtitle {
          font-size: 1rem;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
      .view__content {
        padding: 0;
      }
    }
    .application_banner {
      // background: linear-gradient(160deg, #4608ad, #32067c);
      // background: linear-gradient(180deg, #061387, #4259ed);
      // background: linear-gradient(180deg, #4259ed, #061387);
      // background: linear-gradient(180deg, #32067c, #4608ad);
      // background: linear-gradient(180deg, #061387, #4259ed);
      // background: #4608ad;
      // background: #4438df;
      // background: linear-gradient(180deg, #4438df, #48bdfc);
      margin-bottom: -3rem;
      padding-top: 2.5rem;
    }
  }
  @media (min-width: 39.9375em) and (max-width: 63.9375em) {
    .application_banner {
      .amount {
        font-size: 1rem;
        font-weight: 400;
        letter-spacing: 1px;
      }
      .amount .numbers {
        font-size: 1.75rem;
        font-weight: 600;
      }
      .term {
        font-size: 1rem;
      }
    }
  }
  @media (min-width: 40em) {
    .application {
      padding: 1rem;
      .container {
        display: grid;
        grid-template-columns: 15rem 1fr;
        grid-template-areas:
          "full full"
          "side main";
        grid-column-gap: 1rem;
      }
      .content_area {
        grid-area: main;
      }
      .content_area.full {
        grid-area: full;
      }
      .content_area.side {
        grid-area: side;
      }
    }
  }
  @media (min-width: 64em) {
    .application .container {
      grid-template-columns: minmax(15rem, 20rem) minmax(20rem, auto);
      grid-column-gap: 2rem;
    }
  }
}
</style>
